import { Outlet } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export function CarriersLayout() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet title={t('pages.carriers.pagetitle', 'Carriers').toString()} />
			<Outlet />
		</>
	);
}
